// extracted by mini-css-extract-plugin
module.exports = {"paddingSm":"Block_paddingSm__vA7w1","paddingMed":"Block_paddingMed__bljsZ","paddingLrg":"Block_paddingLrg__Aquao"};